import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Home from '@components/Home/Home';
import SuiteKey from '@components/SuiteKey/SuiteKey';
import Careers from '@components/Careers/Careers';
import Charter from '@components/Charter/Charter';
import CompareAircraft from '@components/CompareAircraft/CompareAircraft';
import OurAircraft from '@components/OurAircraft/OurAircraft';
import FAQ from '@components/FAQ/FAQ';
import News from '@components/News/News';
import Partners from '@components/Partners/Partners';
import CustomizedProposal from '@components/CustomizedProposal/CustomizedProposal';
import Safety from '@components/Safety/Safety';
import Leadership from '@components/Leadership/Leadership';
import Legal from '@components/Legal/Legal';
import Subscribe from '@components/Subscribe/Subscribe';
import Suitedeals from '@components/Suitedeals/Suitedeals';
import Quoting from '@components/Quoting/Quoting';
import WelcomeToSuitekey from '@components/WelcomeToSuitekey/WelcomeToSuitekey';
import NewsView from '@components/NewsView/NewsView';
import BrokerRelations from '@components/BrokerRelations/BrokerRelations';
import Experiences from '@components/Experiences/Experiences';
import ExperiencesLandingPage from '@components/ExperiencesLandingPage/ExperiencesLandingPage';
import ExclusiveExperience from '@components/ExclusiveExperience/ExclusiveExperience';
import NovemberPromotions from '@components/NovemberPromotions/NovemberPromotions';
import NotFound from '@components/NotFound/NotFound';

// Layouts
import Default from '@components/Layout/Default';
import Regular from '@components/Layout/Regular';
import Simple from '@components/Layout/Simple';

export const Router = props => (
  <Switch>
    <Route
      path={'/'}
      exact
      render={() => (
        <Simple pageWidth={props.pageWidth}>
          <CustomizedProposal {...props} />
        </Simple>
      )}
    />
    {/*<Route
      path={'/quoting'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Quoting {...props} />
        </Default>
      )}
    />
    <Route
      path={'/welcome-to-suitekey-membership'}
      exact
      render={() => (
        <Simple pageWidth={props.pageWidth}>
          <WelcomeToSuitekey {...props} />
        </Simple>
      )}
    />
    <Route
      path={'/about-us'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Home {...props} />
        </Default>
      )}
    />
    <Route
      path={'/suitekey-membership'}
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <SuiteKey {...props} />
        </Default>
      )}
    />
    <Route
      path={'/careers'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Careers {...props} />
        </Default>
      )}
    />
    <Route
      path={'/charter'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Charter {...props} />
        </Default>
      )}
    />
    <Route
      path={'/wholesale'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <BrokerRelations {...props} />
        </Default>
      )}
    />
    <Route
      path={'/compare-aircraft'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <CompareAircraft {...props} />
        </Default>
      )}
    />
    <Route
      path={'/our-aircraft'}
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <OurAircraft {...props} />
        </Default>
      )}
    />
    <Route
      path={'/our-aircraft/p100'}
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <OurAircraft {...props} />
        </Default>
      )}
    />
    <Route
      path={'/our-aircraft/p300'}
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <OurAircraft {...props} />
        </Default>
      )}
    />
    <Route
      path={'/our-aircraft/l650'}
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <OurAircraft {...props} />
        </Default>
      )}
    />
    <Route
      path={'/faq'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <FAQ {...props} page={'faq'} />
        </Default>
      )}
    />
    <Route
      path={'/experiences-faq'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <FAQ {...props} page={'experiences'} />
        </Default>
      )}
    />

    <Route
      path={'/news'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <News {...props} />
        </Default>
      )}
    />
    <Route
      path={'/news/:slug'}
      render={props2 => (
        <Simple pageWidth={props.pageWidth}>
          <NewsView {...props2.match.params} {...props} />
        </Simple>
      )}
    />
    <Route
      path={'/partners'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Partners {...props} />
        </Default>
      )}
    />
    <Route
      path={'/partners/:slug'}
      render={props2 => (
        <Default pageWidth={props.pageWidth}>
          <Partners {...props2.match.params} {...props} />
        </Default>
      )}
    />
    <Route
      path={'/contact-us'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <CustomizedProposal {...props} />
        </Default>
      )}
    />
    <Route
      path={'/safety'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Safety {...props} />
        </Default>
      )}
    />
    <Route
      path={'/leadership'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Leadership {...props} />
        </Default>
      )}
    />
    <Route
      path={'/legal'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Legal {...props} />
        </Default>
      )}
    />
    <Route
      path={'/subscribe'}
      exact
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Subscribe {...props} />
        </Default>
      )}
    />
    <Route
      path={'/suitedeal'}
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Suitedeals {...props} />
        </Default>
      )}
    />
    <Route
      path={'/suitedeals'}
      render={() => (
        <Default pageWidth={props.pageWidth}>
          <Suitedeals {...props} />
        </Default>
      )}
    />
    <Redirect from={'/aircraft'} to={'/our-aircraft'} />
    <Redirect from={'/board'} to={'/leadership'} />
    <Redirect from={'/fleet'} to={'/our-aircraft'} />
    <Redirect from={'/why-be-member'} to={'/suitekey-membership'} />
    <Route
      path={'/jetsuite-experiences'}
      exact
      render={() => (
        <Regular pageWidth={props.pageWidth}>
          <Experiences {...props} />
        </Regular>
      )}
    />
    <Route
      path={'/jetsuite-experiences/:slug'}
      render={props2 => (
        <Regular pageWidth={props.pageWidth}>
          <ExperiencesLandingPage {...props2.match.params} {...props} />
        </Regular>
      )}
    />
    <Route
      path={'/exclusive-experience'}
      render={() => (
        <Regular pageWidth={props.pageWidth}>
          <ExclusiveExperience {...props} />
        </Regular>
      )}
    />
    <Route
      path={'/promotions/2019-november'}
      render={() => (
        <Regular pageWidth={props.pageWidth}>
          <NovemberPromotions {...props} />
        </Regular>
      )}
    />

    <Route
      path={'*'}
      render={() => (
        <Regular pageWidth={props.pageWidth}>
          <NotFound {...props} />
        </Regular>
      )}
    />*/}

    <Redirect to={'/'} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/components/Router.jsx